export default "__VITE_ASSET__C4YSt4wD__"